import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTextLanguageAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5 7.25C12.7572 7.25 13.9003 7.73843 14.75 8.53588V8C14.75 7.58579 15.0858 7.25 15.5 7.25C15.9142 7.25 16.25 7.58579 16.25 8V16C16.25 16.4142 15.9142 16.75 15.5 16.75C15.0858 16.75 14.75 16.4142 14.75 16V15.4641C13.9003 16.2616 12.7572 16.75 11.5 16.75C8.87665 16.75 6.75 14.6234 6.75 12C6.75 9.37665 8.87665 7.25 11.5 7.25ZM11.5 8.75C9.70507 8.75 8.25 10.2051 8.25 12C8.25 13.7949 9.70507 15.25 11.5 15.25C13.2949 15.25 14.75 13.7949 14.75 12C14.75 10.2051 13.2949 8.75 11.5 8.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.75 6.5C2.75 4.42893 4.42893 2.75 6.5 2.75H17.5C19.5711 2.75 21.25 4.42893 21.25 6.5V17.5C21.25 19.5711 19.5711 21.25 17.5 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V6.5ZM6.5 4.25C5.25736 4.25 4.25 5.25736 4.25 6.5V17.5C4.25 18.7426 5.25736 19.75 6.5 19.75H17.5C18.7426 19.75 19.75 18.7426 19.75 17.5V6.5C19.75 5.25736 18.7426 4.25 17.5 4.25H6.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconTextLanguageAlt as ReactComponent };
